export const translationEn = {
  leftMenuHeader: {
    newPatient: 'New Patient',
    onboarding: 'Onboarding',
    home: 'Home',
    patients: 'Patients',
    individuals: 'Individuals',
    plans: 'Plans',
    forms: 'Forms',
    library: 'Library',
    calendar: 'Calendar',
    availability: 'Availability',
    reports: 'Reports',
    covenants: 'Covenants',
    events: 'Events',
    templates: 'Templates',
    template: 'Create new Template',
    editTemplate: 'Template Detail',
    readings: 'Readings',
    reading: 'Create new Reading',
    editReading: 'Reading Detail',
    settings: 'Settings',
    profile: 'Edit profile',
    program: 'Create new Program',
    editProgram: 'Program Detail',
    programs: 'Programs',
    company: 'Create new Company',
    editCompany: 'Company Detail',
    companiesList: 'Companies',
    notification: 'Create Notification',
    chat: 'Chat',
    activePauses: 'Active Breaks',
    createActivePause: 'Create Active Break',
    editActivePause: 'Update Active Break',
    audioList: 'Audios',
    audioDetail: 'Audio Detail',
    createAudio: 'Create new Audio',
    shortVideos: 'Short videos',
    shortVideoDetail: 'Short video detail',
    createShortVideo: 'Create new short video',
    eviePrograms: 'Evie programs',
    evieProgramDetail: 'Evie program detail',
    createEvieProgram: 'Create new Evie program',
    squeezes: 'Squeezes',
    squeeze: 'Squeeze detail',
    createSqueeze: 'Create new squeeze',
    squeezeDetail: 'Squeeze detail',
    assets: 'Media files',
    companies: {
      invite: 'Invite an employee',
      employees: 'Employees',
      rewards: 'Rewards',
      orders: 'Orders',
      invoices: 'Invoices',
      teamCount: {
        actual: 'Your current team is',
        of: 'out of',
        button: 'Upgrade your plan',
      },
    },
  },
  navigation: {
    profile: 'My Profile',
    subscriptions: 'My Subscriptions',
    terms: 'Terms & Conditions',
    policy: 'Privacy Policy',
    logout: 'Log out',
  },
  settings: {
    payment: {
      title: 'Benefits Program',
      description: 'Configure payment information for your employees benefits',
      allowance: 'Allowance',
      cadence: 'Cadence',
      type: 'Payment Type',
      method: 'Payment Method',
      creditCard: 'Credit Card',
      reimbursement: 'Reimbursement',
      ondemand: 'On Demand',
      subscription: 'Subscription',
      bank: 'Bank Account',
      changeType: '* To change payment type you must contact the administrator',
      yearly: 'Yearly',
      bi_yearly: 'Biyearly',
      quarterly: 'Quarterly',
    },
    profile: {
      title: 'Profile',
      companyDescription:
        'In this section you can edit the personal information of your profile, adding the basic data and logo that your employees will see in the mobile app.',
      clinicDescription:
        'In this section you can edit the personal information of your profile, adding the basic data and logo that your patients will see in the mobile app.',
    },
    language: {
      label: 'Set your language:',
      title: 'Language',
      description: 'Set your default language for the platform here.',
      placeholder: 'Select language',
    },
    team: {
      title: 'HR Team',
      description: 'Here you can add HR members to receive admin notifications from the platform.',
      addBtn: 'Add team member',
      addModal: {
        addTitle: 'Add member to the team',
        updTitle: 'Update team member',
      },
      emptyState: {
        title: 'You don´t have any team member added!',
      },
    },
  },
  button: {
    delete: 'Delete',
    cancel: 'Cancel',
    exit: 'Exit',
    create: 'Create',
    update: 'Update',
    remove: 'Remove',
    add: 'Add',
    back: 'Back',
    buy: 'Buy',
    next: 'Next',
    edit: 'Edit',
    invite: 'Invite',
    change: 'Change',
    save: 'Save',
    send: 'Send',
    signin: 'Sign In',
    signout: 'Sign Out',
    retrieve: 'Retrieve',
    clinics: 'Clinics',
    companies: 'Companies',
    apply: 'Apply',
    setup: 'Set Up',
    continue: 'Continue',
    duplicate: 'Duplicate',
    addImage: 'Add image',
    categories: 'Categories',
    upload: 'Upload',
    plan: 'See my plan',
    assign: 'Assign program',
    logout: 'Logout',
    ok: 'Ok',
    skip: 'Skip',
    accept: "Yes, I'll take it",
    maybeLater: 'No, maybe later',
    changePassword: 'Change password',
    saveChanges: 'Save Changes',
  },
  nofound: {
    title: 'No results have been found',
    description:
      'Make sure the criteria is spelled correctly or try adjusting the filter to find what you are looking for.',
  },
  searchLabel: {
    employees: 'Search for an employee',
    individuals: 'Search for an individual',
    rewards: 'Search for a product',
    orders: 'Search for an order',
    program: 'Search for a program',
    companies: 'Search for a company',
    activePauses: 'Search for an active break',
    invoices: 'Search Invoice',
    squeeze: 'Search Squeeze',
    asset: 'Search image',
  },
  filterLabel: {
    companies: 'Filter by company',
  },
  tabs: {
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    shareLink: 'Share link',
    specialInvitation: 'Special invitation',
    unfulfilled: 'Unfulfilled',
    fulfilled: 'Fulfilled',
  },
  formLabel: {
    title: 'Title',
    description: 'Description',
    name: 'Name',
    lastName: 'Last name',
    email: 'Email',
    workEmail: 'Work email',
    contactNumber: 'Contact number',
    address: 'Address',
    promoCode: 'Promo code',
    image: 'Image',
    status: 'Status',
    price: 'Price in points',
    quantity: 'Quantity',
    country: 'Country',
    password: 'Password',
    confirmPassword: 'Confirm password',
    id: 'Identification',
    nit: 'NIT',
    phone: 'Phone',
    city: 'City',
    contact: 'Contact person',
    specialist: 'Number of specialists',
    employee: 'Number of employees',
    doctorName: 'Doctor Name',
    duration: 'Duration',
    plan: 'Plan',
    backgroundImage: 'Background Image',
    thumbnailImage: 'Thumbnail Image',
    posterImage: 'Poster Image',
    doctorImage: 'Doctor Image',
    survey: 'Survey',
    from: 'From',
    to: 'To',
    bodyParts: 'Body parts',
    color: 'Color',
    month: 'Month',
    year: 'Year',
    esHeadingLabel: 'Title content in Spanish',
    enHeadingLabel: 'Title content in English',
    esTextLabel: 'Content of the text block in Spanish',
    enTextLabel: 'Content of the text block in English',
    imageUrlLabel: 'Image or gif url',
    esOptionsLabel: 'Spanish Options',
    enOptionsLabel: 'English Options',
    bold: 'Bold',
    type: 'Type',
    goal: 'Goal',
    laps: 'Laps',
    rest: 'Rest (seconds)',
    date: 'Date',
    datepick: 'Select a date',
    hour: 'Hour',
    timeZone: 'Time zone',
    message: 'Message',
    actions: 'Actions',
    action: 'Action',
    file: {
      text: 'Drag and drop a file here, or click to select',
      button: 'Add file',
    },
  },
  placeholder: {
    country: 'Select country',
    plan: 'Select plan',
    template: 'Select Template',
    day: 'Select day',
    survey: 'Select Survey',
    searchExercise: 'Exercise name',
    audio: 'Search for an audio',
    shortVideo: 'Search for a short video',
    textarea: 'Type your answer',
  },
  tableHeader: {
    title: 'Title',
    image: 'Image',
    doctor: 'Doctor',
    duration: 'Duration',
    name: 'Name',
    employees: 'Number of employees',
    content: 'Content',
  },
  deleteForm: {
    title: 'This action is not reversible. Please be certain',
    description: 'This form will be deleted, along with all of its configurations and questions.',
  },
  leaveCreatePatient: {
    description: 'You will not be able to edit this information once you click on Exit.',
  },
  notification: {
    deleteForm: 'The form has been successfully deleted.',
    order: 'Order has been successfully fulfilled',
    updateProfile: 'The profile has been successfully updated.',
    updatePassword: 'Password has been successfully updated.',
    passwordRecovery: 'In your email you will find the link to reset your password.',
    passwordRecovered: 'You have successfully recovered your password.',
    push: 'The PUSH notification has been successfully created.',
    coupon: 'Coupon has been applied successfully.',
    updateEmployeeStatus: 'The employee has been successfully updated.',
    program: {
      create: 'The program has been successfully created',
      update: 'The program has been successfully updated',
    },
    company: {
      create: 'Company has veen successfully created',
      update: 'Company has been successfully updated',
    },
    warning: {
      availability: 'There is already a space in this time frame',
      followupModal: 'Be sure to save the information before continuing, otherwise click cancel again.',
      selectedItem: 'The item has already been selected',
    },
    success: {
      availability: 'Availability has been successfully saved.',
      booking: 'The call has been successfully scheduled',
    },
    activePause: {
      create: 'The active break has been successfully created',
      update: 'The active break has been successfully updated',
    },
    createReading: {
      success: {
        create: 'The reading has been successfully created.',
        update: 'The reading has been successfully updated.',
      },
    },
    completeAudio: {
      success: 'Audio completed successfully!',
      error: 'Error completing audio',
    },
  },
  changePassword: {
    title: 'Change password',
    show: 'Show password',
    label: {
      new: 'New password',
      confirm: 'Confirm new password',
    },
    validation: {
      match: 'Passwords must match',
      uppercase: 'At least one capital letter (A-Z)',
      lowercase: 'At least one lowercase letter (a-z)',
      number: 'At least one number (0-9)',
      character: 'At least one special character',
      length: 'At least 8 characters',
    },
  },
  createEmployee: {
    success:
      'We have sent all the information to create a HealthPhy user for companies in the email you provided us. If you have any questions, please contact us at info@healthphy.de',
  },
  editProfile: {
    title: 'My profile',
  },
  createTemplate: {
    readings: {
      team: 'Evie Team',
      feedback: 'was this content helpful?',
      title: {
        all: 'All Readings',
        own: 'Readings in this Template',
      },
    },
  },
  surveys: {
    welcome: {
      message:
        'Hello, you have been sent a survey from the HealthPhy platform, below you will find options to fill out as clearly as possible. This information is confidential, so when you are ready click on the button below.',
      button: 'Take questionnaire',
    },
    survey: {
      section: 'Section {{current}} of {{length}}',
      fileUpload: 'Upload a file',
    },
    completed: {
      thanksInit: 'You can now start your personalized exercises',
      thanks: 'Thank you very much for your answers',
      data: 'These are your login details',
      user: 'User name:',
      password: 'Password',
      success: 'The survey has been successfully completed and the answers will be analyzed by your professional.',
      reminder: 'Remember to change the password once you enter the app to validate your entry in the platform.',
      download: 'Download it now',
    },
  },
  billing: {
    clinicTitle: "You take care of providing your best service. We'll take care of your patients",
    clinicDescription:
      'At HealthPhy you pay for the number of active patients you have, making it easy to tailor the plan to your needs, with different payment options, according to your needs, without long-term contracts or complex licenses. You can cancel your subscription at any time with no additional costs or cancellation fees.',
    companyTitle: "You take care of providing your best service. We'll take care of your team.",
    companyDescription:
      'At HealthPhy you pay for the number of active employees you have, making it easy to tailor the plan to your needs, with different payment options, according to your needs, without long-term contracts or complex licenses. You can cancel your subscription at any time with no additional costs or cancellation fees.',
    clinicChoose: 'Escoge el número de pacientes:',
    companyChoose: 'Choose the number of active employees in your organization:',
    clinicPerks: {
      library: 'Biblioteca con cientos de ejercicios terapéuticos para crear el programa perfecto de rehabilitación.',
      plans: 'Planes de rehabilitación preconfigurados por nuestros especialistas',
      custom: 'Editor de planes personalizados de tratamiento según la necesidad de cada paciente.',
      remote: 'Atención remota por medio de Videollamadas encriptadas en la plataforma para mayor seguridad.',
      statistics: 'Estadísticas y monitoreo del proceso de recuperación.',
      tailor:
        '* Nos adaptamos a tu necesidad, si los videos de la plataforma no se adaptan a ti, ofrecemos grabación de vídeos a medida cuando adquieres un plan igual o superior a 6 meses.',
    },
    companyPerks: {
      surveys:
        'Surveys to identify and evaluate risk factors for musculoskeletal, vascular and psychosocial disorders.',
      plans: 'Preventive exercise plans and personalized active breaks plan.',
      programs:
        'Programs for management and education on common chronic diseases (hypertension, diabetes, obesity, COPD and/or musculoskeletal injuries).',
      appointments:
        'Access to the possibility of scheduling appointments with physiotherapists or psychologists in less than 48 hours.',
      support: 'Accompaniment for the implementation of digital wellness.',
      statistics: 'Initial report with diagnostic statistics of work-related illnesses for decision-making.',
    },
    planCard: {
      subscription: 'Subscription',
      name: {
        yearly: 'Yearly',
      },
      discount: 'Discount',
      save: 'Save',
    },
    users: {
      patient: 'Patient',
      employee: 'Employee',
      patients: 'Patients',
      employees: 'Employees',
    },
    timePeriod: {
      monthly: '(monthly)',
    },
    stepIndicator: {
      method: 'Payment method',
      detail: 'Payment details',
      confirm: 'Confirm payment',
    },
    paymentMethod: {
      useCards: 'Use your credit cards',
      choose: 'Choose payment method',
    },
    summary: {
      title: 'Payment details',
      selectedPlan: 'Selected plan',
      subtotal: 'Subtotal',
      discount: 'Discount',
      total: 'Total',
      coupon: 'Coupon',
    },
    paymentData: {
      billingInfo: 'Billing information',
      cardInfo: 'Card information',
      terms:
        'I understand and accept the <contract>end user license agreement</contract> and <privacy>privacy policy</privacy> for making this purchase.',
    },
    paymentSummary: {
      title: 'Confirm your information',
      standard: 'Standard subscription plan',
      creditCard: 'Credit card',
      button: 'Confirm and pay',
      totalPayment: 'Total payment',
      total: 'Total',
    },
    success: {
      title: 'Successful transaction',
      message:
        'Great! The payment for your plan has been successfully processed. Shortly you will receive the information of this transaction through your e-mail. If you have any questions, please do not hesitate to contact us at',
      button: 'Back to home',
      expires: 'Expires on',
    },
  },
  employees: {
    empty: {
      emptyTitle: "You don't have any employees registered in your team yet!",
      invitationLink: {
        share: 'Share the',
        link: 'invitation link',
        join: 'to get them to start joining.',
      },
    },
    tableHeader: {
      name: 'Name',
      status: 'Status',
      email: 'Email',
      activity: 'Activity',
      changeStatus: 'Active/Inactive',
    },
    invite: {
      title: 'Options for adding an employee',
      description:
        'Copy this link and share it with your team by email, intranet, slack, etc. Each team member with access to the link will get a Healthphy account to start making their work sessions more productive.',
      button: 'Copy link',
    },
    employeeSpend: {
      header: {
        employeLabel: 'Balance available in benefits',
        companyLabel: 'Amount of company allowance',
      },
      emptyInvoiceItems: {
        label: 'has no spent products yet',
      },
    },
  },
  rewards: {
    available: 'available',
    empty: {
      title: "You don't have any added rewards for your employees yet!",
      description: 'Start by creating products for your employees to claim as prizes.',
    },
    tableHeader: {
      name: 'Name',
      status: 'Status',
      stock: 'Stock',
      detail: 'Detail/Edit',
    },
    productDetail: {
      title: 'Product detail',
      name: 'Name',
      description: 'Description',
      image: 'Image',
      status: 'Status',
      price: 'Price in points',
      quantity: 'quantity',
    },
    addProduct: {
      addTitle: 'Add a new product',
      updateTitle: 'Update product',
      placeholderStatus: 'Select the status for the product',
      status: {
        active: 'Active',
        inactive: 'Inactive',
      },
    },
    button: {
      add: 'Add product',
      update: 'Update product',
    },
  },
  orders: {
    empty: {
      title: "You don't have any orders yet!",
      description: 'Stay tuned! you will see a list of created orders from your employees',
      button: 'Go to employees',
    },
    tableHeader: {
      name: 'Name',
      status: 'Status',
      employee: 'Employee',
      createdAt: 'Created at',
      detail: 'Detail/Edit',
    },
    orderDetail: {
      product: 'Product',
      quantity: 'Quantity',
      points: 'Points',
      employee: 'Employee',
      button: 'Fulfill',
    },
  },
  howToWin: {
    howto: 'How to earn points?',
    points:
      'Points are extra motivation to stay healthy. You can get them by doing your daily workouts or by enrolling to the different programs within the app.',
    whatcan: 'What can I use them for?',
    exchange:
      'You can exchange your points for many great products/items, you will find them in the "Redeem points" section at the top of the screen.',
  },
  redeemProduct: {
    title: 'Redeem Product',
    table: {
      product: 'Product',
      quantity: 'Qty.',
      points: 'Points',
    },
    resume: {
      title: 'Resume',
      currentPoints: 'Current points',
      total: 'Total',
      remainingPoints: 'Remaining points',
    },
    button: 'Redeem',
    loading: 'Loading',
    authError: 'You need to authenticate to perform this action',
    pointsError: "You don't have enough points for this item, you need ",
    more: 'more',
    successRedeem: 'Your product has been successfully redeem, enjoy it!',
    errorRedeem: 'Sorry, we are having issues with your request',
    quantityError: 'Sorry, we ran out of inventory',
  },
  createProgram: {
    step: {
      detail: 'Program Detail',
      readingTemplate: 'Reading Templates',
      audio: 'Add Audio',
    },
  },
  programs: {
    button: 'Create Program',
    duration: 'days',
  },
  companies: {
    createButton: 'Create Company',
  },
  trial: {
    ended: {
      title: 'Your trial period is over!',
      message:
        'Thank you for using and testing our platform, we hope you enjoyed the free version. To continue enjoying the services of our platform, upgrade your subscription by choosing any of our plans.',
      button: 'See plans',
    },
    period:
      'This account is in a trial period and has <span>{{trialDays}} days</span> to go, access one of our plans to upgrade your account.',
  },
  login: {
    welcome: 'Welcome to HealthPhy',
    forgot: 'Forgot your password?',
    recover: 'Password recovery',
    recoverMessage: 'Enter your email address and we will send you a link to recover access to your account.',
    access: 'Recover access to your account',
    empty: 'This link is invalid or has expired.',
  },
  tooltip: {
    selectAll: 'Select all',
    unselectAll: 'Unselect all',
  },
  forms: {
    previewTitle: 'This is how your patient will see the form',
  },
  introModal: {
    title: "Welcome to Healthphy, let's set up your account.",
    description:
      'Welcome to HealthPhy, to use the platform you need to configure your profile and login information, in the following screens we will help you to do it.',
  },
  changeStatusAlert: {
    title: 'Change Status',
    description: 'This action will change the status of <strong>{{name}}</strong>',
  },
  modalAlert: {
    updateEmployerPlan: {
      title: 'Update Plan',
      message: 'You have reached the allowed number of employees for your plan.',
    },
  },
  availability: {
    title: 'Edit time availability',
    description:
      'Configure the blocks of time per day that you have available to attend your patients on calls or to attend events.',
    weekDays: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
  },
  deletePlan: {
    title: 'This action is not reversible, are you sure?',
    description: 'This plan will be deleted, including all its content and settings.',
  },
  activePauses: {
    createButton: 'Create Active Break',
    emptyState: {
      title: 'You don`t have active breaks configured yet!',
      subtitle: 'Start by setting up your first active break for employee assessment.',
    },
  },
  createActivePause: {
    exercisesTitle: 'Search for an exercise',
    selectedExercisesTitle: 'Videos',
  },
  emptyState: {
    description:
      'Make sure the criteria is spelled correctly or try adjusting the filter to find what you are looking for.',
  },
  audioList: {
    createButton: 'Create Audio',
    emptyState: {
      title: 'You don`t have any audios configured yet!',
      description: 'Start by setting up an audio to complement your patient`s program.',
    },
    tableHeader: {
      title: 'Título',
      description: 'Descripción',
    },
  },
  invoices: {
    header: {
      amount: 'Amount due',
      dueDate: 'Due date',
      items: 'Items',
      status: 'Status',
      invoices: 'Invoices',
    },
    filters: {
      months: {
        '01': 'January',
        '02': 'February',
        '03': 'March',
        '04': 'April',
        '05': 'May',
        '06': 'June',
        '07': 'July',
        '08': 'August',
        '09': 'September',
        10: 'October',
        11: 'November',
        12: 'December',
      },
    },
    tableHeader: {
      employee: 'Employee',
      program: 'Program',
      date: 'Date',
      amount: 'Amount',
      download: 'Download',
    },
    tableBody: {
      markAsPaidBtn: 'Mark as paid',
    },
  },
  readings: {
    editTitle: {
      label: 'Title and image for the reading',
    },
    blockTypes: {
      block: 'Block content',
      heading1: 'Heading 1',
      heading2: 'Heading 2',
      heading3: 'Heading 3',
      text: 'Text block',
      image: 'Image',
      bulletList: 'Bullet list',
      divider: 'Divider',
    },
    editor: {
      label: 'Block Editor',
      description: 'Select the type of block to add it to the reading and modify its content.',
      configLabel: 'Block configuration',
    },
    preview: {
      emptyState: 'The preview of your reading starts here.',
    },
  },
  shorVideos: {
    createBtn: 'Create short video',
    emptyState: {
      title: '¡You don´t have short videos configured yet!',
      description: 'Start by creating a short video to complement the program your employee will be taking.',
    },
  },
  eviePrograms: {
    createBtn: 'Create Evie program',
    emptyState: {
      title: 'You don´t have Evie programs configured yet!',
      description: 'Starts creating an Evie program for women´s empowerment',
    },
    steps: {
      description: 'Description',
      levels: 'Levels',
      additionalContent: 'Additional content',
    },
    detail: {
      title: 'Build your program',
      editorLabel: 'Add a program description',
    },
    levels: {
      title: 'Customize each level of your program, add as many as you need',
      addLevelBtn: 'Add Level',
      addSessionBtn: 'Add Session',
      labelLevel: 'Level',
    },
    level: {
      title:
        'Customize each session of the level, add exercises and Squeezes, define the time of their duration, you can also add sessions as needed.',
      labelSession: 'Sessionn',
      exerciseSession: 'Level {{levelPosition}} / Session {{sessionPosition}}',
      infoTitle: 'Update level information',
      blockTitle: 'Update the information of the exercise block',
    },
    session: {
      addExBlockBtn: 'Add block of exercises',
      addTaskBlockBtn: 'Add block of tasks',
      addExercise: 'Add exercises to the session',
      addSqueeze: 'Add squeezes to the session',
    },
    warning: {
      levelTitle: 'Are you sure you want to remove the level?',
      sessionTitle: 'Are you sure you want to remove the session?',
      excerciseTitle: 'Are you sure you want to remove the exercise block?',
    },
    additionalContent: {
      title: 'Customize each level of your program, add additional content as needed',
      titleLevel: 'Add additional content to the level',
      selectedItems: {
        label: 'Selection summary',
        count: '{{length}} exercises',
      },
    },
    itemsHeader: {
      readings: {
        label: 'Readings',
        description: 'Manage the readings of the level, add the ones you want according to the needs of the program',
      },
      audios: {
        label: 'Audios',
        description: 'Manage the audios of the level, add the ones you want according to the needs of the program',
      },
      shortVideos: {
        label: 'Short Videos',
        description:
          'Manage the short videos of the level, add as many as you want according to the needs of the program',
      },
      exercises: {
        label: 'Exercises',
        description: 'Manage the exercises of the level, add the blocks you want according to the needs of the program',
      },
      tasks: {
        label: 'Tasks',
        description: 'Manage the level Tasks, add the blocks you want according to the needs of the program',
      },
    },
  },
  patient: {
    personalInfo: {
      btns: {
        book: 'Book a call',
      },
      booking: {
        title: 'Book a call',
        titleUpdate: 'Reschedule the call',
        description: 'Book a call and make a personalized follow-up to your patient`s exercise program',
      },
    },
  },
  squeezes: {
    createBtn: 'Create squeeze',
    actions: {
      release: 'Release',
      hold: 'Hold',
      squeeze: 'Squeeze',
      rest: 'Rest',
    },
    emptyState: {
      title: 'You don`t have squeezes configured yet!',
      description: 'Start by creating a squeeze to complement your patients` plans.',
    },
  },
  evieOnboarding: {
    welcome: {
      title: 'Welcome <br /> to Evie',
      subtitle: 'Welcome to Evie',
      pathSelector: {
        content: 'Select the condition for which you would like to consult',
        conditions: {
          pregnancy: 'Pregnancy',
          postpartum: 'Postpartum',
          incontinence: 'Incontinence',
          sexualPain: 'Other',
        },
      },
    },
    infoScreen: {
      pregnancy: {
        title1: 'Prepare for your birth',
        description1:
          'Learn how to push, breathing techniques, birthing positions and reduce the risk of injury, whether vaginal birth or cesarean section.',
        title2: 'Control your pelvic floor',
        description2:
          'Get personalized pelvic exercises to prevent or treat urinary leakage, sexual pain, constipation and much more.',
        title3: 'Connect with your body',
        description3:
          'Access physiotherapists who are experts in female pelvic health and who will guide you to feel strong and prepared for childbirth.',
      },
      postpartum: {
        title1: 'Postpartum recovery',
        description1:
          'Leaking when you sneeze? Pain during sex? Feeling like something is falling down there? Your postpartum body deserves attention.',
        title2: 'Control your pelvic floor',
        description2:
          'Recover your pelvic and abdominal muscles to confidently return to your activities, from exercise to enjoying your intimate life.',
        title3: 'Connect with your body',
        description3:
          'Get guidance from physiotherapists who are experts in female pelvic health and start feeling unstoppable again.',
      },
      pain: {
        title1: 'Relieve your symptoms',
        description1:
          'Leaking when you sneeze? Pain during sex? Feeling like something is falling down there? Your body deserves attention.',
        title2: 'Control your pelvic floor',
        description2:
          'Get personalized pelvic exercises to prevent or treat urinary leakage, sexual pain, constipation and much more.',
        title3: 'Connect with your body',
        description3:
          'Access physiotherapists who are experts in female pelvic health and who will guide you to feeling strong, confident and whole again.',
      },
    },
    userName: "What's your name?",
    userNamePlaceholder: 'Enter your name',
    quizStarter: {
      title1: 'About your pregnancy',
      title2: 'About your postpartum',
      title3: 'About your pelvic health',
      description:
        'Please answer the following questions as clearly as possible. We will use your answers to provide you with the best care and treatment. Your information is confidential, everything you share stays here.',
      confidential: 'Your information is confidential, everything you share stays here.',
      button: 'Next',
    },
    signup: {
      title: 'Where should we send your perzonalized plan?',
      description: 'Enter your email:',
      description1: 'Enter your password:',
      emailPlaceholder: 'example@gmail.com',
      passwordPlaceholder: 'Password',
      submitButton: 'Next',
      privacy: "We won't share your personal data with anyone",
    },
    perkScreen: {
      title1: 'Conscious pregnancy and birth',
      title2: 'Postpartum recovery',
      title3: 'Pelvic health',
      description1: 'Your personalized pregnancy program',
      description2: 'Your personalized postpartum program',
      description3: 'Your personalized pelvic health program',
      button: 'Start your program',
      perks: {
        physio: 'Assessment with physiotherapists',
        chat: 'Private chat with health experts',
        exercises: 'Pelvic coordination exercises',
        routines: 'Personalized routines for every day',
        audio: 'Readings, audios and interactive capsules',
      },
    },
    planScreen: {
      title: 'A plan that works for you',
      button: 'Start my 7 free days',
      subtitle: 'Designed by pelvic floor physiotherapists · your questions answered 24/7',
      skipLink: "I'd rather start without a card",
      personalizedTitle: {
        pregnancy: 'Your birth-preparation plan is ready, {{name}}',
        postpartum: 'Your postpartum recovery plan is ready, {{name}}',
        pain: 'Your pelvic health plan is ready, {{name}}',
        fallback: 'Your personalized plan is ready',
      },
      fineprint: {
        reminder: "We'll remind you on day 5. Cancel before day 7 and you pay nothing.",
        chargeAnnual: "First charge: {{price}} on {{date}}. Per month, that's ~70% less than a physiotherapy session.",
        chargeMonthly: 'First charge: {{price}} on {{date}}.',
        refund: "Annual plan: if it's not for you, we refund you within the first 30 days.",
        cancel: 'You can cancel in seconds from the link in your confirmation email.',
      },
      testimonials: {
        title: 'Women like you',
        pregnancy: {
          meli: {
            content:
              'I had my dream birth — no epidural, no complications. I got to the clinic at 8 cm dilated, ready to push.',
            author: 'Meli, 33 years old',
          },
          angie: {
            content:
              'I was afraid of a second C-section. Thanks to the exercises, my baby was born vaginally in just 5 pushes — and I treated all my symptoms.',
            author: 'Angie, 32 years old',
          },
          kathe: {
            content:
              'I felt safe and in control of my body during labor. I arrived at 7 cm dilated with good pain management. One of the most positive experiences of my life!',
            author: 'Katherine, 28 years old',
          },
          evi: {
            content:
              'During my pregnancy my abdomen was weak and I had back and hip pain. With the exercises I regained my strength, and my baby was born vaginally in just 4 hours.',
            author: 'Evi, 31 years old',
          },
        },
        postpartum: {
          angie: {
            content:
              'I experienced urine leakage when sneezing during my second pregnancy. With pelvic exercises and guidance from my therapist, I was able to reduce the leakage in just two weeks.',
            author: 'Angie, 32 years old',
          },
          caro: {
            content:
              'After my pregnancy, my abdomen was weak and the muscles were separated. I followed the exercises and regained the firmness and strength that I had lost.',
            author: 'Caro, 37 years old',
          },
          tati: {
            content:
              'My postpartum recovery was faster than I thought, I resumed relations with my partner without pain and with a lot of confidence.',
            author: 'Tatiana, 30 years old',
          },
        },
        pain: {
          luisa: {
            content:
              "Today I added jumping jacks to my workout routine and I didn't have any urine leaks. This is the first time this has happened to me in many years. WOW!",
            author: 'Luisa, 38 years old',
          },
          pao: {
            content:
              "Thanks to Evie's sexual health program, my pain during penetration during sex has improved by 90%, I feel more confident about myself. Thank you!",
            author: 'Paola, 32 years old',
          },
          anna: {
            content:
              'I used to have frequent urinary tract infections and thought this was normal. I have not had any more infections for 3 months now, and I have also gotten to know my body and learned new pelvic habits.',
            author: 'Anna, 32 years old',
          },
        },
      },
      offering: {
        monthly: 'Monthly',
        annual: 'Yearly',
        trial: '7-day free trial',
        freeMonthTrial: 'One month free',
        discount: '{{percentage}}% discount',
        access: 'Full access to the program',
        savingsChip: 'SAVE 33%',
        annualBonus: 'Includes your physiotherapist assessment · 45 min',
        monthlyAccess: 'Full access · without the 1:1 assessment',
        perMonth: '/mo',
        save: 'Save {{amount}}',
        billed: {
          monthly: 'Month to month',
          annual: '{{price}} per year',
        },
        warranty: '<strong>RISK-FREE:</strong> we remind you on day 5. Cancel before day 7 and you pay nothing.',
        terms:
          'You are subscribing to a monthly or annual plan in the <strong>Evie Health</strong> app after your <strong>7 free days</strong>. When the 7 days end, your plan renews automatically and the charge is applied to the card you provided. Annual plan: if it is not for you, we refund you within the first 30 days. You can cancel anytime from the link in your confirmation email; if you need help, write to us at <strong>info@hievie.com</strong>. The charge will appear on your statement as Healthphy OÜ.',
      },
    },
    trialScreen: {
      title: 'How your 7 free days work',
      button: 'Start my 7 free days',
      cancelFaq: 'Is cancelling easy? Yes — from the link in your confirmation email, in seconds.',
      steps: {
        stepOne: {
          title: 'Questionnaire completed',
          content: 'Your personalized plan is ready',
        },
        stepTwo: {
          title: 'Today: full access, free',
          content: 'Unlimited program and assistant — you pay nothing today',
        },
        stepThree: {
          title: "Day 5: we'll tell you — we promise",
          content: 'Email and notification before any charge',
        },
        stepFour: {
          title: 'Day 7: you decide',
          content: 'You continue with your plan for {{price}}, assessment included. Or you cancel in seconds, no charge.',
        },
      },
    },
    loadingScreen: {
      title: 'Crafting Your Personalized Plan',
      content:
        "Hang tight! We're analyzing your responses to design a tailored plan that fits your needs. This won't take long. Thank you for your patience!",
    },
    thankyouScreen: {
      title: 'Your Evie membership is now active',
      content: 'To start your journey:',
      btn: 'Download now',
      backToAssistantBtn: 'Back to assistant',
      steps: {
        one: '1. Download the Evie app.',
        two: '2. Log in to your account.',
        qr: 'Or, scan the QR code below:',
      },
    },
    setPhoneScreen: {
      title: '✅ Your 7 free days have started!',
      description: 'Set your password to access your account anytime.',
      setPhone: 'Help us communicate better with you.',
      btn: 'Save and Continue',
      placeholder: {
        country: 'Country',
        phone: 'Phone',
        password: 'New Password',
        confirmPassword: 'Confirm Password',
      },
    },
    indexScreen: {
      header: {
        btn: 'See my plan',
        freeBtn: 'Start your free trial without a card',
      },
      banner: {
        percentage: 'Save',
        deadline: 'Offer expires in:',
      },
      hero: {
        pregnancy: {
          title: '"I managed to have my dream birth',
          quote: 'without epidural and without any complications',
          description:
            'With the <strong>conscious birth preparation program,</strong> I arrived at the clinic dilated at 8, ready to give birth."',
          userName: 'Mely Polo, 33 years old',
        },
        postpartum: {
          title: '"My postpartum recovery was faster',
          quote: 'I got back sexual intercourse with my partner',
          description:
            'pain-free and very confident, thanks to the <strong>recovery</strong> program I returned to my routine sooner than I expected."',
          userName: 'Tatiana, 32 years old',
        },
        pain: {
          title: '"I managed to reduce urine loss',
          quote: 'after two weeks in the program',
          description:
            'of <strong>incontinence</strong>. Through pelvic exercises and guidance from my physical therapist, <strong>I was able to laugh and jump without fear"</strong>.',
          userName: 'Angie, 33 years old',
        },
      },
      goals: {
        pregnancy: {
          nowCard: {
            tag: 'Now',
            key1: 'Pelvic dysfunction',
            value1: 'Moderate',
            key2: 'Level of preparation',
            value2: 'Low',
            key3: 'Confidence in childbirth',
            value3: 'Acceptable',
          },
          goalCard: {
            tag: 'Your goal',
            key1: 'Pelvic dysfunction',
            value1: 'No symptoms',
            key2: 'Level of preparation',
            value2: 'High',
            key3: 'Confidence in childbirth',
            value3: 'High',
          },
        },
        postpartum: {
          nowCard: {
            tag: 'Now',
            key1: 'Pelvic dysfunction',
            value1: 'Moderate',
            key2: 'Recovery',
            value2: 'Slow',
            key3: 'Sexual appetite',
            value3: 'Low',
          },
          goalCard: {
            tag: 'Your goal',
            key1: 'Pelvic dysfunction',
            value1: 'No symptoms',
            key2: 'Recovery',
            value2: 'Fast',
            key3: 'Sexual appetite',
            value3: 'High',
          },
        },
        pain: {
          nowCard: {
            tag: 'Now',
            key1: 'Pelvic dysfunction',
            value1: 'Moderate',
            key2: 'Urine leaks',
            value2: 'Moderate',
            key3: 'Esteem and security',
            value3: 'Low',
          },
          goalCard: {
            tag: 'Your goal',
            key1: 'Pelvic dysfunction',
            value1: 'No symptoms',
            key2: 'Urine leaks',
            value2: 'None',
            key3: 'Esteem and security',
            value3: 'Hight',
          },
        },
      },
      benefits: {
        pregnancy: {
          title: 'What will you learn in this program?',
          card1: 'Exercises to activate and make the pelvic floor more flexible.',
          card2: 'Guidance on safe birthing positions and effective pushing methods.',
          card3: 'Breathing techniques to relieve pain and reduce the risk of tearing during childbirth.',
          card4: 'Guidelines for creating your birth plan and having a positive experience.',
        },
        postpartum: {
          title: 'What will you learn in this program?',
          card1: 'Exercises to activate and make the pelvic floor more flexible.',
          card2: 'Guidance on how to increase your libido and get your sex life back on track.',
          card3: 'Techniques to relieve pain and reduce urinary and/or defecation symptoms.',
          card4: 'Recommendations for safely resuming sports activities.',
        },
        pain: {
          title: 'What will you learn in this program?',
          card1: 'Exercises to activate and make the pelvic floor more flexible.',
          card2: 'Guidance on how to increase your libido and get your sex life back on track.',
          card3: 'Techniques to relieve pain and reduce urinary and/or defecation symptoms.',
          card4: 'Recommendations for safely resuming sports activities.',
        },
      },
      infoData: {
        pregnancy: {
          title: 'Prepare your body for childbirth',
          qoute: 'Feel safe and prepared',
          content: 'to welcome your baby.',
        },
        postpartum: {
          title: 'Recover your body after childbirth',
          qoute: 'Feel safe and prepared',
          content: 'to enjoy you as a woman.',
        },
        pain: {
          title: 'Recover your body after childbirth',
          qoute: 'Feel safe and prepared',
          content: 'to enjoy you as a woman.',
        },
      },
      programContent: {
        pregnancy: {
          title: "What's included?",
          card1:
            "<strong>Initial assessment</strong> of 45 minutes with your physiotherapist expert in women's health.",
          card2: '<strong>Pelvic exercises</strong> personalized for every day.',
          card3: '<strong>Educational content</strong> and access to a community of women.',
          card4: '<strong>Support</strong> from your physiotherapist throughout the entire process and 24/7 chatting.',
        },
        postpartum: {
          title: "What's included?",
          card1:
            "<strong>Initial assessment</strong> of 45 minutes with your physiotherapist expert in women's health.",
          card2: '<strong>Pelvic exercises</strong> personalized for every day.',
          card3: '<strong>Educational content</strong> and access to a community of women.',
          card4: '<strong>Support</strong> from your physiotherapist throughout the entire process and 24/7 chatting.',
        },
        pain: {
          title: "What's included?",
          card1:
            "<strong>Initial assessment</strong> of 45 minutes with your physiotherapist expert in women's health.",
          card2: '<strong>Pelvic exercises</strong> personalized for every day.',
          card3: '<strong>Educational content</strong> and access to a community of women.',
          card4: '<strong>Support</strong> from your physiotherapist throughout the entire process and 24/7 chatting.',
        },
      },
      infoData1: {
        pregnancy: {
          label1: 'We have held more than',
          label2: '5000 virtual sessions',
          label3: 'impacting more than',
          label4: '1000 women',
          label5: 'Level of satisfaction',
        },
        postpartum: {
          label1: 'We have held more than',
          label2: '5000 virtual sessions',
          label3: 'impacting more than',
          label4: '1000 women',
          label5: 'Level of satisfaction',
        },
        pain: {
          label1: 'We have held more than',
          label2: '5000 virtual sessions',
          label3: 'impacting more than',
          label4: '1000 women',
          label5: 'Level of satisfaction',
        },
      },
    },
    assistantSection: {
      chip: 'YOUR ASSISTANT',
      heading: 'Ask anything, any time, <br />no shame',
      assistantName: 'Evie',
      status: 'available now',
      inputPlaceholder: 'Type your question...',
      timestampGreeting: '10:46 pm',
      timestampReply: '10:47 pm',
      trust: {
        availabilityTitle: 'Answers 24/7',
        availabilitySubtitle: 'based on your test and stage',
        expertsTitle: 'Physios behind it',
        expertsSubtitle: 'AI built with our team',
      },
      cta: 'Ask your first question',
      disclosure: 'AI assistant built together with our physiotherapists.',
      postpartum: {
        greeting:
          'Hi {{name}} 💗 I read your answers: you are in your postpartum and marked leaks when sneezing and discomfort during sex. Both have a solution. Where should we start?',
        greetingNoName:
          'Hi 💗 I read your answers: you are in your postpartum and marked leaks when sneezing and discomfort during sex. Both have a solution. Where should we start?',
        chipOther: 'Pain during sex',
        chipSelected: 'The leaks 💧',
        userMessage: 'The leaks... they happen when I sneeze or laugh 😔',
        answer:
          "It happens to 1 in 3 moms and almost no one talks about it. Your pelvic floor can get stronger and you'll feel the difference within weeks. Let's start today 💗",
        exerciseTitle: 'Strengthen your pelvic floor',
        exerciseSubtitle: 'Guided exercise · 5 min',
      },
      pregnancy: {
        greeting:
          "Hi {{name}} 💗 I read your answers: you are pregnant and want to prepare for birth. Let's do it calmly and without fear. Where should we start?",
        greetingNoName:
          "Hi 💗 I read your answers: you are pregnant and want to prepare for birth. Let's do it calmly and without fear. Where should we start?",
        chipOther: 'Is it safe to exercise?',
        chipSelected: 'Preparing for birth 💗',
        userMessage: 'I want to prepare for birth and avoid tearing',
        answer:
          "With pelvic floor and breathing exercises you lower the risk of tearing and reach birth with more control. Let's start today 💗",
        exerciseTitle: 'Prepare your pelvis for birth',
        exerciseSubtitle: 'Guided exercise · 5 min',
      },
      incontinence: {
        greeting:
          'Hi {{name}} 💗 I read your answers: you marked urine leaks and want to regain control. It has a solution. Where should we start?',
        greetingNoName:
          'Hi 💗 I read your answers: you marked urine leaks and want to regain control. It has a solution. Where should we start?',
        chipOther: 'Why does it happen?',
        chipSelected: 'The leaks 💧',
        userMessage: 'The leaks... they happen when I sneeze or laugh 😔',
        answer:
          "It happens to 1 in 3 women and almost no one talks about it. Your pelvic floor can get stronger and you'll feel the difference within weeks. Let's start today 💗",
        exerciseTitle: 'Strengthen your pelvic floor',
        exerciseSubtitle: 'Guided exercise · 5 min',
      },
      sexual: {
        greeting:
          "Hi {{name}} 💗 I read your answers: you marked discomfort during sex. You don't have to live with it: it has a solution. Where should we start?",
        greetingNoName:
          "Hi 💗 I read your answers: you marked discomfort during sex. You don't have to live with it: it has a solution. Where should we start?",
        chipOther: 'The dryness',
        chipSelected: 'Pain during sex 💗',
        userMessage: "It hurts and I don't enjoy it like before 😔",
        answer:
          "It happens to more women than you think and almost no one talks about it. By relaxing and strengthening your pelvic floor you'll feel the difference within weeks. Let's start today 💗",
        exerciseTitle: 'Release your pelvic floor tension',
        exerciseSubtitle: 'Guided exercise · 5 min',
      },
    },
    testResultsScreen: {
      title: 'Your result Pelvic dysfunction:',
      result: 'Moderate',
      level: 'High level 7.5',
      description:
        '<strong>Pelvic floor dysfunction (PFD)</strong> occurs when the muscles in this area are weak, tight, or uncoordinated.',
      symptoms: {
        sexual: {
          label: 'Sexual pleasure',
          level: 'Below normal',
        },
        urinary: {
          label: 'Urinary symptoms',
          level: 'Below normal',
        },
        bowel: {
          label: 'Bowel function',
          level: 'Average',
        },
      },
    },
  },
  inputValidation: {
    required: 'Required',
    email: 'Invalid email',
    password: 'Password must be at least 8 characters long, an uppercase letter and a number',
    match: 'Passwords must match',
    emailLikeName: "That looks like an email — what's your name?",
  },
  assets: {
    createTitle: 'Create new media file',
    selectTitle: 'Selet media file',
    emptyState: {
      title: "You don't have any media files created yet!",
      content: 'Start by creating a media file for your project configuration',
    },
    btn: 'Create',
  },
  alert: {
    assignProgram: {
      title: 'Are you sure you want to assign this program?',
      description: 'This will be the new program with which your user will interact in the mobile application',
    },
  },
  evieApp: {
    magicLink: {
      title: 'Support for your pelvic health',
      description: "We'll email you a link to sign in. No password needed.",
      cta: 'Send me a link',
      trust:
        'A private space to understand and care for your pelvic health — through pregnancy, postpartum and beyond. Evie complements your medical care. It never replaces it.',
      signupPrompt: 'New to Evie?',
      signupCta: 'Sign up →',
      sentTitle: 'Check your email',
      sentDescription: 'Tap the link we sent you to sign in. It works for 30 minutes.',
      sentSpam: "Haven't received it? Check your spam folder.",
      changeEmail: 'Change email →',
      verifyingTitle: 'Signing you in…',
      invalidTitle: 'This link is no longer valid',
      invalidDescription:
        'This link expired, or a newer one was sent — only the most recent link works. Sign in again to request a new one.',
      unreachableTitle: "We couldn't complete your sign-in",
      unreachableDescription: 'Check your connection, then sign in again to request a new link.',
      backToLogin: 'Back to sign in',
      requestFailed: "We couldn't send the link. Please check your connection and try again.",
    },
    programTitle: 'Your personal program',
    bottomNav: {
      home: 'Home',
      assistant: 'Assistant',
      program: 'Program',
      profile: 'Settings',
      activity: 'Activity',
    },
    programInfoCard: {
      title: 'Your personalized program',
      content: 'Discover it and start today.',
    },
    dailyTasksCard: {
      day: 'Day',
      todaysPlan: "Today's plan",
      completed: 'Completed',
      unlockedBtn: 'See my personalized program',
      lockedBtn: 'Unlock to continue',
    },
    seeMore: {
      exLabel: 'Exercises',
      weekLabel: 'Week 1',
      squeezeLabel: 'Squeezes',
      actionLabel: 'See more',
    },
    dailyExerciseCard: {
      title: 'Daily exercises',
      content: 'Strengthen your pelvic floor with our guided sessions.',
      guideLabel: 'Guided session',
      timeLabel: '5 min',
    },
    goPlusCard: {
      title: 'Go plus!',
      content: 'to enjoy your personal program',
    },
    squeezeCard: {
      title: 'Daily squeeze',
      content: 'A different exercise every day',
    },
    contentCard: {
      readingLabel: 'Reading',
      capsuleLabel: 'Capsule',
      audioLabel: 'Audio',
    },
    programInfo: {
      units: 'Units',
      unit: 'Unit',
      descriptionTitle: 'What is your program about?',
      benefitsTitle: 'Learn about the benefits',
      contentTitle: 'Your content',
      startBtn: 'Start now',
    },
    countDown: {
      skipButton: 'Skip',
      breakLabel: 'Take a break',
      nextLabel: 'The next series will start soon',
    },
    leaveSession: {
      title: 'Leave session',
      content: "Do you really want to leave today's session?",
    },
    instructionsModal: {
      title: 'Instructions',
    },
    exercises: {
      controls: {
        label: 'Exercise',
        reps: 'Repetitions',
        laps: 'Lap',
      },
      sessionCompleted: {
        title: 'You completed your exercises',
        content: 'We would like to know your condition to improve in your following sessions',
      },
    },
    audio: {
      timeUnit: 'minutes',
    },
    squeeze: {
      actions: {
        rest: 'Rest',
        hold: 'Hold',
        release: 'Relax',
        squeeze: 'Squeeze',
      },
    },
    sessionInfo: {
      title: 'Today exercises',
      duration: {
        seconds: 'seconds',
        minutes: 'minutes',
      },
    },
    profile: {
      title: 'Profile',
      pwTitle: 'Change password',
      settings: {
        title: 'Settings',
        setting: {
          data: 'My data',
          see: 'See your personal data',
        },
      },
      terms: {
        terms: 'Terms & conditions',
        privacy: 'Privacy policy',
        feedback: 'Give us your opinion',
      },
      personalData: {
        name: 'Name',
        email: 'Email',
        currentProgram: 'Current program',
      },
    },
    program: {
      title: 'Program',
      levelLabel: 'Level',
      sessionLabel: 'Session',
      exLabel: 'Exercises',
      squeezeLabel: 'Squeezes',
      additionalContent: 'Additional content',
      doneForToday: "You're done for today",
      unitInfoLabel: 'Program information',
    },
    assistant: {
      chatInput: {
        placeholderEmpty: 'Start messaging...',
        placeholderDefault: 'Type your message...',
      },
      welcomeMessage: {
        label: "¡Hello! <strong>I'm here to help you</strong> with any questions about your pelvic floor health.",
      },
      quickReplies: {
        label: 'Please tap any that apply:',
      },
      dayLabel: {
        today: 'Today',
        yesterday: 'Yesterday',
      },
      recommendations: {
        exercise: 'Do the full exercise here',
        audio: 'Listen to the full audio here',
        shortVideo: 'Watch the full video here',
        reading: 'Read the full article here',
        squeeze: 'Do the full squeeze here',
        fallback: 'See more details',
      },
      testResultModal: {
        title: 'Pelvic result:',
        subtitle: 'Moderate pelvic dysfunction',
        rate: 'High level 9.5',
        description:
          '<strong>Pelvic floor dysfunction (PFD)</strong> occurs when the muscles in this area are weak, tight, or uncoordinated.',
      },
      errors: {
        sendMessage: 'Error sending message. Please try again.',
        connectionError: 'Something went wrong. Please check your connection and try again.',
      },
      messagesLeft: {
        label: '{{count}} free messages left today.',
        singular: '{{count}} free message left today.',
        upgrade: 'Upgrade',
      },
    },
    home: {
      title: 'Hello,',
      subtitle: 'Start your exercises for today',
    },
    activity: {
      title: 'Activity',
      header: {
        pointsLabel: 'Earned points',
        points: 'Points',
        streak: 'Streak',
        days: 'Days',
        description: 'Earn points by completing different tasks and exercises during your week.',
      },
      logs: {
        content: {
          audio: 'Audio completed',
          reading: 'Reading completed',
          capsule: 'Video completed',
        },
        exerciseSession: 'Session completed',
        survey: 'Survey completed',
        programsessionexercise: 'Exercise session completed',
        programsessionsqueeze: 'Squeeze session completed',
      },
    },
    feedback: {
      skipBtn: 'Skip',
      title: 'How was your exercise day?',
      content: 'We would like to know your condition to improve in your next sessions.',
      wellbeingScale: {
        levelTitle: "What was your pain level during today's session?",
        reliefTitle: 'Do you feel relief?',
        commentsTitle: 'Leave us a comment',
        options: {
          low: 'Low',
          moderate: 'Moderate',
          high: 'High',
        },
      },
    },
    leaveFreeTrial: {
      title: 'Your personalized plan is waiting',
      content: 'Start free with your assistant — no card. Your plan stays saved for whenever you want it.',
      accept: 'Start free, no card',
      dismiss: 'Not now',
    },
    scheduleCall: {
      title: 'Schedule a call with a specialist',
      subtitle: 'Personalize your program',
      confirm: 'Confirm appointment',
      done: 'Done',
      scheduled: {
        title: 'You already have an appointment scheduled!',
        modal: {
          title: 'Scheduled appointment',
          message: 'You already have an appointment scheduled on',
          ok: 'Ok',
        },
      },
      modal: {
        title: 'Schedule a call',
        back: 'Back',
        videoCall: 'Video call',
        duration: '15 min',
        timezone: 'Times are shown according to your time zone:',
        viewMore: 'View more schedule',
        continue: 'Continue',
        confirm: {
          title: 'Confirm your appointment',
          duration: 'Duration:',
          date: 'Date:',
          time: 'Time:',
          message: 'Please review your appointment details above. Click confirm to schedule your session.',
          button: 'Confirm Appointment',
          scheduling: 'Scheduling...',
        },
        success: {
          title: 'Congratulations!',
          message: 'Your appointment has been successfully scheduled for',
          details: 'You will receive a confirmation email shortly with all the details.',
          lookingForward: 'We look forward to seeing you!',
          done: 'Done',
        },
        notes: {
          title: 'How can we help you on this call?',
          placeholder: 'Add any additional information or notes for your appointment...',
        },
        selection: {
          message: 'You have not yet chosen a day for your appointment.',
          selected: 'Selected date:',
        },
      },
    },
    login: {
      title: 'Sign in',
      description: 'Login into your account',
      welcome: 'Welcome to Evie',
    },
    chatActions: {
      todaySession: {
        title: 'Go to today’s session',
      },
    },
  },
};
